import Edit from './Edit';
import List from './List';
import NewInstallerUser from './NewInstallerUser.jsx';
import InstallerList from './InstallerList';

export default { Edit, List, NewInstallerUser, InstallerList };



// WEBPACK FOOTER //
// ./src/pages/Users/index.js